export function hasAtMostDecimals(value, decimals) {
    return Number(value.toFixed(decimals)) === value;
}
//# sourceMappingURL=has-at-most-decimals.js.map